import { render } from "./rooms.vue?vue&type=template&id=2b6eff40&scoped=true"
import script from "./rooms.vue?vue&type=script&lang=js"
export * from "./rooms.vue?vue&type=script&lang=js"

import "./rooms.vue?vue&type=style&index=0&id=2b6eff40&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\EngeeGit\\EngeeAPI\\AdminPanel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6eff40"]])

export default __exports__